<template>
  <div class="body">
    <div class="chat-header">
      <img src="@/assets/img/yian-logo.png" />
      <div>AI 全科会诊</div>
    </div>
    <div class="content">
      <div class="left">
        <div class="hirstory" v-for="(item, index) in list" :key="index" @click="getListPcGroupChat(item)">{{ item.firstQuestionDetails }}</div>
      </div>
      <div class="ai-chat-container">
        <!-- <div class="chat-header">
            <h2>AI 助手聊天</h2>
            </div> -->
        <div class="chat-messages" ref="chatMessages">
          <div v-for="(message, index) in messages" :key="index" :class="['message', message.sender]">
            <div class="message-content">
              <img v-if="message.type == 1" src="@/assets/img/ai-close.png" />
              <img v-if="message.type == 2" src="@/assets/img/ai-pdf.png" />
              <div class="message-text">
                <pre>{{ message.content }}</pre>
              </div>
              <div class="message-time">{{ formatTime(message.timestamp) }}</div>
            </div>
          </div>
          <div v-if="AILoading" class="ai">
            <img style="width: 6%" src="https://health-planet.oss-cn-shanghai.aliyuncs.com/report/2025-09-22/37089b50e343ed4aab4839975eca579ffe60.gif" />
          </div>
        </div>
        <div class="chat-input-area">
          <div class="list">
            <div class="file active" v-loading="loading" v-for="(img, index) in imgList" :key="index">
              <img v-if="img.type == 1" :src="img.src" />
              <img v-if="img.type == 2" src="@/assets/img/ai-pdf.png" />
              <img v-if="img.type == 1" style="width: 22px; height: 22px; margin: -2px 0 0 30px" src="@/assets/img/ai-scan.png" @click="scanImg(img.src)" />
              <img v-if="img.type == 2" style="width: 22px; height: 22px; margin: -2px 0 0 30px" src="@/assets/img/ai-scan.png" @click="scanPdf(img.src)" />
              <img class="del" src="@/assets/img/ai-close.png" @click="delFile(index)" />
            </div>
          </div>
          <textarea v-model="inputMessage" placeholder="输入您的问题..." @keyup.enter.ctrl="sendMessage" rows="4"></textarea>
          <div class="button">
            <!-- <button @click="sendMessage" class="send-button">发送</button> -->
            <!-- :on-exceed="handleExceed" -->
            <el-upload
              class="upload-demo"
              action=""
              :http-request="fnUploadRequest"
              :on-preview="handlePreview"
              :on-success="upLoadeSuccess"
              multiple
              :limit="3"
              :accept="acceptTypes"
              :file-list="imgList"
              :show-file-list="false"
            >
              <img style="width: 26px; height: 26px; margin-right: 10px" src="@/assets/img/ai-uploade.png" />
            </el-upload>
            <img src="@/assets/img/ai-send.png" @click="sendMessage" />
          </div>
        </div>
      </div>
    </div>
    <!-- :before-close="handleClose" -->
    <el-dialog title="图片预览" :visible.sync="imgShow" width="50%">
      <img :src="imgUrl" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="imgShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getList, submit, getListByPcGroupChatId, submitPcGroupChatDataInfo, getUserBodyInfo, getBaiLianUploadFileId, getFileStatusByFileId } from '@/api/health/AIManage'
import axios from 'axios'
import { apiKey, appId } from '@/config'

const OSS = require('ali-oss')
const client = new OSS({
  region: 'oss-cn-shanghai',
  endpoint: 'oss-cn-shanghai.aliyuncs.com',
  accessKeyId: 'LTAI4GGYDGZjaZQyshkjPBJH',
  accessKeySecret: '5O9VCIRDa6AqHtVj2NDiMUO9Uv2GDe',
  bucket: 'health-planet'
})

export default {
  name: 'AIChat',
  data() {
    return {
      messages: [
        {
          sender: 'ai',
          content: '您好！我是您的AI助手，有什么可以帮助您的吗？',
          timestamp: new Date()
        }
      ],
      list: [],
      imgList: [],
      inputMessage: '',
      loading: false,
      acceptTypes: '.jpg,.jpeg,.png,.pdf,.PDF',
      imgShow: false,
      imgUrl: '',
      session_id: '',
      wxUserid: '',
      AILoading: false,
      chooseAIId: '',
      fileUrl: null,
      fileId: null,
      bodyDetails: '',
      fileUrlList: [],
      fileIdList: []
    }
  },
  created() {
    this.wxUserId = this.$route.query.wxUserId || '1111111111'
    this.onload()
  },
  mounted() {
    this.scrollToBottom()
  },
  methods: {
    onload() {
      console.log('test onload')
      console.log('test wxUserId', this.wxUserId)
      getList(this.wxUserId).then(res => {
        console.log('wxUserId', this.wxUserId)
        console.log('res', res)
        this.list = res.data
      })
      this.getUserBodyInfoPlan()
    },
    scanImg(img) {
      this.imgShow = true
      this.imgUrl = img
    },
    scanPdf(fileUrl) {
      if (fileUrl) {
        window.open(fileUrl, '_blank')
      } else {
        this.$message.warning('PDF文件地址无效')
      }
    },
    upLoadeSuccess(file) {
      console.log(file)
      // let type = 0;
      // if (file.indexOf('png') > 0 || file.indexOf('jpg') > 0 || file.indexOf('jpeg') > 0) {
      //     type = 1;
      // }
      // if (file.indexOf('pdf') > 0 || file.indexOf('PDF') > 0) {
      //     type = 2;
      // }
      // const userMessage = {
      //     sender: 'user',
      //     content: file,
      //     type: type,
      //     timestamp: new Date()
      // };
      // this.messages.push(userMessage);
    },
    handlePreview(file) {
      console.log(file)
    },
    delFile(index) {
      this.imgList.splice(index, 1)
    },
    // sendMessage() {
    //   if (!this.inputMessage.trim()) return;
    //   const userMessage = {
    //     sender: 'user',
    //     content: this.inputMessage.trim(),
    //     timestamp: new Date()
    //   };
    //   this.messages.push(userMessage);
    //   this.inputMessage = '';
    //   this.scrollToBottom();
    //   // 这里写接口返回的数据
    //   setTimeout(() => {
    //     const aiResponses = [
    //       '我理解您的问题，让我为您解答。',
    //       '这个问题很有趣，我需要思考一下。',
    //       '根据您的描述，我认为可以这样解决。',
    //       '您的问题很重要，让我详细说明。',
    //       '感谢您的提问，这是一个很好的问题。'
    //     ];
    //     const randomResponse = aiResponses[Math.floor(Math.random() * aiResponses.length)];
    //     const aiMessage = {
    //       sender: 'ai',
    //       content: randomResponse,
    //       timestamp: new Date()
    //     };
    //     this.messages.push(aiMessage);
    //     this.scrollToBottom();
    //   }, 1000);
    // },
    // formatTime(timestamp) {
    //   const date = new Date(timestamp);
    //   const hours = date.getHours().toString().padStart(2, '0');
    //   const minutes = date.getMinutes().toString().padStart(2, '0');
    //   return `${hours}:${minutes}`;
    // },
    formatTime(timestamp) {
      const now = new Date(timestamp)
      const year = now.getFullYear().toString()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const date = now.getDate().toString().padStart(2, '0')
      const hours = now.getHours().toString().padStart(2, '0')
      const minutes = now.getMinutes().toString().padStart(2, '0')
      const seconds = now.getSeconds().toString().padStart(2, '0')
      return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`
    },
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.chatMessages) {
          this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight
        }
      })
    },
    // getDateNow(){
    //   const now = new Date()
    //   const year = now.getFullYear().toString();
    //   const month = (now.getMonth()+1).toString().padStart(2, '0');
    //   const date = now.getDate().toString().padStart(2, '0');
    //   const hours = now.getHours().toString().padStart(2, '0');
    //   const minutes = now.getMinutes().toString().padStart(2, '0');
    //   const seconds = now.getSeconds().toString().padStart(2, '0');
    //   return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
    // },
    async submitPcGroupChat(inputDeatils) {
      const row = {
        wxUserId: this.wxUserId,
        firstQuestionDetails: inputDeatils
      }
      console.log('test submitPcGroupChat row', row)
      await submit(row).then(res => {
        console.log('submitPcGroupChat res', res)
        this.chooseAIId = res.data
      })
    },
    getListPcGroupChat(item) {
      console.log('test item', item)
      if (this.loading) return
      getListByPcGroupChatId(this.wxUserId, item.id).then(res => {
        console.log('getListByPcGroupChatId res', res)
        this.messages = res.data
      })
    },
    submitPcGroupChatData(type, info) {
      console.log('test type', type)
      console.log('test info', info)
      this.fileUrl = this.fileUrlList.join(',')
      this.fileId = this.fileIdList.join(',')
      console.log('test fileUrl', this.fileUrl)
      console.log('test fileId', this.fileId)
      const row = {
        pcGroupChatId: this.chooseAIId,
        wxUserId: this.wxUserId,
        infoType: type,
        infoDetails: info,
        fileUrl: this.fileUrl,
        fileId: this.fileId
      }
      submitPcGroupChatDataInfo(row).then(res => {
        console.log('res', res)
        this.restoreData()
      })
    },
    pushMessage(type, info) {
      const message = {
        sender: type === 1 ? 'user' : 'ai',
        content: info,
        timestamp: new Date()
      }
      this.messages.push(message)
      this.submitPcGroupChatData(type, info)
    },
    getUserBodyInfoPlan() {
      getUserBodyInfo(this.wxUserId).then(res => {
        console.log('wxUserId', this.wxUserId)
        console.log('res', res)
        this.bodyDetails = res.data
      })
    },
    clearData(info) {
      info = info.replace(/\*\*\*/g, '')
      info = info.replace(/\*\*/g, '')
      info = info.replace(/\*/g, '')
      info = info.replace(/\-\-\-/g, '')
      info = info.replace(/\-\-/g, '')
      info = info.replace(/\-/g, '')
      info = info.replace(/\#\#\#/g, '')
      info = info.replace(/\#\#/g, '')
      info = info.replace(/\#/g, '')
      return info
    },
    async fnUploadRequest(options) {
      if (this.loading) return
      try {
        const file = options.file // 拿到 file
        const fileName = file.name.substr(0, file.name.lastIndexOf('.'))
        const fileType = file.name.substr(file.name.lastIndexOf('.'))
        console.log('test fileName', fileName)
        console.log('test fileType', fileType)
        const date = new Date().getTime()
        const fileNames = `${date}_${fileName}` + fileType // 拼接文件名，保证唯一，这里使用时间戳+原文件名
        console.log('test fileNames', fileNames)
        // 上传文件,这里是上传到OSS的文件夹下
        client.put(fileNames, file).then(res => {
          console.log('res oss', res)
          if (res.res.statusCode === 200) {
            this.fileUrlList.push(res.url)
            this.loading = true
            const imgDetails = {
              src: res.url,
              type: file.name.substr(file.name.lastIndexOf('.')) === '.pdf' ? 2 : file.name.substr(file.name.lastIndexOf('.')) === '.PDF' ? 2 : 1
            }
            this.imgList.push(imgDetails)
            this.getBaiLianUploadFileIdPlan(res.url)
            options.onSuccess(res)
          } else {
            options.onError('上传失败')
          }
        })
      } catch (e) {
        options.onError('上传失败')
      }
    },
    getBaiLianUploadFileIdPlan(url) {
      const row = {
        url: url
      }
      getBaiLianUploadFileId(row).then(res => {
        console.log('getBaiLianUploadFileId res', res)
        this.fileIdList.push(res.data)
        this.getFileStatusByFileIdPlan(res.data)
      })
    },
    getFileStatusByFileIdPlan(FileId) {
      getFileStatusByFileId(FileId).then(res => {
        console.log('getFileStatusByFileId res', res)
        if (res.data) {
          this.loading = false
          console.log('test fileidList111', this.fileIdList)
        } else {
          setTimeout(() => {
            this.getFileStatusByFileIdPlan(FileId)
          }, 1000)
        }
      })
    },
    restoreData() {
      this.fileUrl = null
      this.fileId = null
      this.fileUrlList = []
      this.fileIdList = []
      this.imgList = []
      this.inputMessage = ''
    },
    async sendMessage() {
      if (this.loading) return
      if (!this.inputMessage.trim()) return
      const url = `https://dashscope.aliyuncs.com/api/v1/apps/${appId}/completion`
      const inputDeatils = this.inputMessage
      const inputFileDeatils = this.fileIdList
      console.log('test inputMessage', this.inputMessage)
      console.log('test fileIdList', this.fileIdList)
      console.log('test inputDeatils', inputDeatils)
      console.log('test inputFileDeatils', inputFileDeatils)
      if (this.chooseAIId === '') {
        this.submitPcGroupChat(inputDeatils)
          .then(() => {
            this.pushMessage(1, inputDeatils)
          })
          .catch(error => {
            console.error('submitPcGroupChat failed:', error)
          })
      } else {
        this.pushMessage(1, inputDeatils)
      }
      this.AILoading = true
      const data = {
        input: {
          prompt: this.bodyDetails + inputDeatils,
          session_id: this.session_id
        },
        parameters: {
          rag_options: {
            session_file_ids: inputFileDeatils
          }
        },
        debug: {}
      }
      try {
        const response = await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${apiKey}`,
            'Content-Type': 'application/json'
          }
        })
        this.session_id = response.data.output.session_id
        console.log('test session_id', this.session_id)
        if (response.status === 200) {
          const outPutDetails = this.clearData(response.data.output.text)
          // this.pushMessage(2, response.data.output.text)
          this.pushMessage(2, outPutDetails)
        } else {
          this.pushMessage(2, '咨询失败请重新咨询')
        }
      } catch (error) {
        this.pushMessage(2, '咨询失败请重新咨询')
      }
      this.AILoading = false
    }
  }
}
</script>

<style scoped>
.body {
  width: 90%;
  margin-left: 5%;
  border-radius: 12px;
}
.content {
  width: 100%;
  display: flex;
}
.content .left {
  width: 20%;
  height: 82vh;
  background-color: #f9fafb;
  padding-left: 20px;
  padding-top: 40px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示为省略号 */
}
.content .left div {
  width: 94%;
  height: 40px;
  line-height: 40px;
  margin-top: 10px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示为省略号 */
}
.button {
  display: flex;
}
.hirstory:hover {
  background-color: #409eff; /* 鼠标移入时背景色变为绿色 */
  color: white; /* 文本颜色变为白色 */
  padding: 0 10px;
  border-radius: 16px;
}
.ai-chat-container {
  display: flex;
  flex-direction: column;
  height: 82vh;
  width: 80%;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
  /* border-radius: 8px; */
  overflow: hidden;
  background-color: #f5f5f5;
}

.chat-header {
  background-color: #409eff;
  color: white;
  padding: 16px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
}
.chat-header div {
  font-size: 30px;
  border-left: 3px solid #fff;
  line-height: 50px;
  height: 50px;
  margin-top: 5px;
  padding-left: 20px;
  font-weight: bold;
  letter-spacing: 2px;
}

.chat-header img {
  width: 280px;
  height: 60px;
  /* margin-top:10px; */
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.message {
  max-width: 70%;
  padding: 12px 16px;
  border-radius: 18px;
  word-wrap: break-word;
}

.message.user {
  align-self: flex-end;
  background-color: #409eff;
  color: white;
  border-bottom-right-radius: 4px;
}

.message.ai {
  align-self: flex-start;
  background-color: white;
  color: #333;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.message-content {
  display: flex;
  flex-direction: column;
}
.message-content img {
  width: 40px;
  height: auto;
}

.message-text {
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 4px;
}

.message-time {
  font-size: 11px;
  opacity: 0.7;
  align-self: flex-end;
}

.chat-input-area {
  width: 90%;
  margin-left: 5%;
  margin-bottom: 10px;
  padding: 16px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
}
.chat-input-area textarea {
  width: 95%;
  margin-bottom: 10px;
  max-height: 200px;
}
.chat-input-area .list {
  display: flex;
}
.chat-input-area .list .file {
  width: 13%;
  height: 40px;
  border: 1px solid #e0e0e0;
  display: flex;
  text-align: center;
  justify-content: space-between;
  padding: 6px 10px;
  border-radius: 6px;
  margin-right: 10px;
}
.chat-input-area .list .active {
  width: 13%;
  height: 46px;
  border: 1px solid #e0e0e0;
  display: flex;
  text-align: center;
  justify-content: space-between;
  border-radius: 6px;
  margin-right: 10px;
}

.list .file .del {
  width: 16px !important;
  height: 16px !important;
}
.chat-input-area textarea {
  flex: 1;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  resize: none;
  font-size: 14px;
  line-height: 1.5;
  outline: none;
  transition: border-color 0.2s;
}

.chat-input-area textarea {
  border: none;
  max-height: 200px;
}
.chat-input-area img {
  width: 30px;
  height: 30px;
  /* margin-right: 10px; */
}

textarea {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

/* 针对WebKit内核的浏览器 */
textarea::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

textarea::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

textarea::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
  border: 3px solid #f1f1f1;
}

textarea::-webkit-scrollbar-thumb:hover {
  background: #555;
}

textarea::-webkit-scrollbar-corner {
  background: #f1f1f1;
}

.send-button {
  padding: 12px 24px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
  height: fit-content;
}

.send-button:hover {
  background-color: #66b1ff;
}

.send-button:active {
  background-color: #3a8ee6;
}

/* 滚动条样式 */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
